import Header from "./Header";
import Footer from "./Footer";
import "./AboutPage.css";

const AboutPage = () => {
  return (
    <>
      <Header />
      <img
        src={require("./Assets/Profielfoto.png")}
        alt="Foto van Rein"
        className="profielfoto"
      />
      <p className="bio">
        Ik ben iemand die het prettig vindt om complexe systemen helemaal tot op
        het bot uit te pluizen. En dit is precies wat ik ervaar tijdens het
        schrijven van code. In mijn tijd bij Qquest heb ik ontdekt dat ik met
        plezier urenlang geconcentreerd kan blijven programmeren. Het geeft me
        erg veel voldoening om een lastig probleem op te lossen, nieuwe dingen
        te leren en een steeds breder begrip te ontwikkelen van de taal waar ik
        op dat moment mee schrijf. Ik vind het vervolgens ook leuk om kennis te
        delen met anderen, om zo efficiënt mogelijk te kunnen werken.
      </p>
      <Footer />
    </>
  );
};

export default AboutPage;
